// extracted by mini-css-extract-plugin
export var cdBlogProductCard = "blog-product-card-module--cd-blog-product-card--35db5";
export var cdBlogProductCardAtc = "blog-product-card-module--cd-blog-product-card-atc--919e4";
export var cdBlogProductCardImage = "blog-product-card-module--cd-blog-product-card-image--59f31";
export var cdBlogProductCardLeft = "blog-product-card-module--cd-blog-product-card-left--be42f";
export var cdBlogProductCardPrice = "blog-product-card-module--cd-blog-product-card-price--f93c6";
export var cdBlogProductCardRight = "blog-product-card-module--cd-blog-product-card-right--bbfdd";